import React, { useRef, useState, useEffect } from "react"
import { Link } from "gatsby"
import { gsap } from "gsap/dist/gsap"

import { ControlledCarouselProps } from "./ControlledCarousel.interface"
import * as s from "./Carousel.module.scss"

export const ControlledCarousel = ({
  data,
  styleType,
  selectedSlide,
  onChange,
  isPaused,
  children,
}: ControlledCarouselProps) => {
  const { slides } = data
  const images = data.images
  const tl = new gsap.timeline()
  const _progress = useRef(null)
  const hasMultiSlides = slides && slides.length > 1
  const [selected, setSelected] = useState(false)
  const activeSlide = selectedSlide

  useEffect(() => {
    if (!hasMultiSlides) return

    if (isPaused || selected) return

    tl.to(_progress.current, 0.4, {
      scaleX: 1,
    })
      .set(_progress.current, {
        transformOrigin: "right",
      })
      .to(_progress.current, 0.4, {
        scaleX: 0,
      })
      .set(_progress.current, {
        scaleX: 0,
        transformOrigin: "left",
      })
      .to(_progress.current, 15.5, {
        scaleX: 1,
      })
  }, [activeSlide])

  const handleSelect = () => {
    /*eslint-disable*/
    setSelected(prev => {
      return true
    })
  }
  /*eslint-enable*/
  const StyleClass = () => {
    switch (styleType) {
      case "BRAND":
        return s.Carousel__brand
        break
      case "SLIDESHOW":
        return s.Carousel__slideShow
        break
      default:
        break
    }
  }

  return (
    <div className={`${s.Carousel} ${s.Carousel__accordian} ${StyleClass()}`}>
      {slides &&
        slides.map((slide, i) => (
          <div
            key={i}
            className={`${s.Slide} ${activeSlide === i && s.Slide___active}`}
            style={
              slide.image
                ? {
                    backgroundImage: `url(${
                      slide.image && slide.image.sourceUrl
                    })`,
                  }
                : {}
            }
          ></div>
        ))}

      {!slides && images && (
        <>
          {images.map((slide, i) => (
            <>
              <Link
                key={`Slide${i}`}
                className={`${s.Slide__link} ${
                  activeSlide === i && s.Slide___active
                }`}
                to={`/shop/${data.handle}`}
              >
                <div
                  className={`${s.Slide} ${
                    activeSlide === i && s.Slide___active
                  }`}
                  key={i}
                  style={{
                    backgroundImage: `url(${slide.originalSrc})`,
                  }}
                />
              </Link>
            </>
          ))}
          {children}
        </>
      )}

      {hasMultiSlides && (
        <div className={`${s.Progress} ${s.Progress__accordian} `}>
          <div
            className={s.Progress__container}
            style={{
              opacity: isPaused || selected ? 0 : 1,
            }}
          >
            <div
              className={`${s.Progress__bar__progress} ${s.Progress__bar__progressAccordian}`}
              ref={_progress}
            />
            <div className={s.Progress__bar} />
          </div>
          <div
            className={`${s.Progress__dots} ${s.Progress__dots___accordian}`}
          >
            {slides.map((slide, i) => (
              <div
                onClick={() => {
                  onChange(i), handleSelect()
                }}
                key={`slide${i}`}
                className={`${s.Progress__dots__dot} ${
                  activeSlide === i && s.Progress__dots__dot___active
                }`}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
